import { ActionTypes } from '../../constants/ActionTypes';
import { ThemeSetting } from '../../constants/ThemeSetting';
import { ILocal } from '../../interfaces';

const { LAYOUT_TYPE, THEME_COLOR, THEME_TYPE } = ThemeSetting;

export function updateWindowWidth(width: number) {
  return (dispatch: (arg: { type: any; width: number }) => void) => {
    dispatch({ type: ActionTypes.WINDOW_WIDTH, width });
  };
}

export function setThemeType(themeType: string | null) {
  return (dispatch: Function) => {
    dispatch({ type: THEME_TYPE, themeType });
  };
}

export function setThemeColor(themeColor: string | null) {
  return (dispatch: Function) => {
    dispatch({ type: THEME_COLOR, themeColor });
  };
}

export function onLayoutTypeChange(layoutType: string | null) {
  return (dispatch: Function) => {
    dispatch({ type: LAYOUT_TYPE, layoutType });
  };
}

export function switchLanguage(locale: ILocal) {
  return (dispatch: Function) => {
    dispatch({
      type: ActionTypes.SWITCH_LANGUAGE,
      payload: locale,
    });
  };
}
